module.exports = __webpack_public_path__ + "assets/57ec586c229c43b7cd69a5dff8af71db.png";